export const getIsoCountry = (title: string) => {
  switch (title) {
    case 'Guadeloupe':
      return 'GP';
    case 'Martinique':
      return 'MQ';
    case 'Mayotte':
      return 'YT';
    case 'Réunion':
      return 'RE';
    case 'French Guiana':
      return 'GF';
    default:
      return 'FR';
  }
};
